<template>
<div>
<main>
     <div class="blue-outline">
      <div class="flex-group">
  <div class="text">
    <h1 style="color: #003A7F;">Newsletter</h1>
    <!-- Begin Mailchimp Signup Form -->
<link href="//cdn-images.mailchimp.com/embedcode/classic-071822.css" rel="stylesheet" type="text/css">

<div id="mc_embed_signup">
    <form action="https://pferdeverstand.us11.list-manage.com/subscribe/post?u=19fd06a118fa480d31595ba93&amp;id=1e34179e56&amp;f_id=004e9fe0f0" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" class="validate" target="_blank" novalidate>
        <div id="mc_embed_signup_scroll">
        <h2>Anmeldung zum Newsletter</h2>
        <div class="indicates-required"><span class="asterisk">*</span> erforderliches Feld</div>
<div class="mc-field-group">
	<label for="mce-EMAIL">Email-Adresse  <span class="asterisk">*</span>
</label>
	<input type="email" value="" name="EMAIL" class="required email" id="mce-EMAIL" required>
	<span id="mce-EMAIL-HELPERTEXT" class="helper_text"></span>
</div>
<div class="mc-field-group">
	<label for="mce-FNAME">Vorname  <span class="asterisk">*</span>
</label>
	<input type="text" value="" name="FNAME" class="required" id="mce-FNAME" required>
	<span id="mce-FNAME-HELPERTEXT" class="helper_text"></span>
</div>
<div class="mc-field-group">
	<label for="mce-LNAME">Nachname  <span class="asterisk">*</span>
</label>
	<input type="text" value="" name="LNAME" class="required" id="mce-LNAME" required>
	<span id="mce-LNAME-HELPERTEXT" class="helper_text"></span>
</div>
	<div id="mce-responses" class="clear foot">
		<div class="response" id="mce-error-response" style="display:none"></div>
		<div class="response" id="mce-success-response" style="display:none"></div>
	</div>    <!-- real people should not fill this in and expect good things - do not remove this or risk form bot signups-->
    <div style="position: absolute; left: -5000px;" aria-hidden="true"><input type="text" name="b_19fd06a118fa480d31595ba93_1e34179e56" tabindex="-1" value=""></div>
        <div class="optionalParent">
            <div class="clear foot">
                <input type="submit" value="Anmelden" name="subscribe" id="mc-embedded-subscribe" class="button">
                <p class="brandingLogo"><a href="http://eepurl.com/iazj3P" title="Mailchimp - email marketing made easy and fun"><img src="https://eep.io/mc-cdn-images/template_images/branding_logo_text_dark_dtp.svg" style="opacity: 0.5%"></a></p>
            </div>
        </div>
    </div>
</form>
</div>
</div>
</div>
<!--End mc_embed_signup-->
  </div>
</main>
</div>
</template>

<script type='text/javascript' src='//s3.amazonaws.com/downloads.mailchimp.com/js/mc-validate.js'></script><script type='text/javascript'>(function($) {window.fnames = new Array(); window.ftypes = new Array();fnames[0]='EMAIL';ftypes[0]='email';fnames[1]='FNAME';ftypes[1]='text';fnames[2]='LNAME';ftypes[2]='text'; /*
 * Translated default messages for the $ validation plugin.
 * Locale: DE
 */
$.extend($.validator.messages, {
	required: "Dieses Feld ist ein Pflichtfeld.",
	maxlength: $.validator.format("Geben Sie bitte maximal {0} Zeichen ein."),
	minlength: $.validator.format("Geben Sie bitte mindestens {0} Zeichen ein."),
	rangelength: $.validator.format("Geben Sie bitte mindestens {0} und maximal {1} Zeichen ein."),
	email: "Geben Sie bitte eine gültige E-Mail Adresse ein.",
	url: "Geben Sie bitte eine gültige URL ein.",
	date: "Bitte geben Sie ein gültiges Datum ein.",
	number: "Geben Sie bitte eine Nummer ein.",
	digits: "Geben Sie bitte nur Ziffern ein.",
	equalTo: "Bitte denselben Wert wiederholen.",
	range: $.validator.format("Geben Sie bitten einen Wert zwischen {0} und {1}."),
	max: $.validator.format("Geben Sie bitte einen Wert kleiner oder gleich {0} ein."),
	min: $.validator.format("Geben Sie bitte einen Wert größer oder gleich {0} ein."),
	creditcard: "Geben Sie bitte ein gültige Kreditkarten-Nummer ein."
});}(jQuery));var $mcj = jQuery.noConflict(true);</script>

<script>
export default {
  name: "Newsletter",
   metaInfo() {
        return { 
            title: "Pferdeverstand - Newsletter abonnieren",
            meta: [
                { name: 'description', content:  'Melde dich jetzt an und erhalte alle Infos als Erstes'},
                { property: 'og:title', content: "Pferdeverstand.at - Newsletter abonnieren"},                
                { property: 'og:description', content: "Melde dich jetzt an und erhalte alle Infos als Erstes"},
                { property: 'og:image', content: '../assets/img/og/pferdeverstand-logo.png'},
                { property: 'og:url', content: 'www.pferdeverstand.at/newsletter'}
            ]
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/Newsletter.vue